<template>
  <div>

    <div class="hero-video">
      <video
          ref="heroVideo"
          autoplay
          muted
          loop
          playsinline
          preload="auto"
          class="hero-video__player"
          @loadeddata="onVideoLoaded"
          @ended="onVideoEnded"
      >
        <source src="@/assets/videos/hero-video.mp4" type="video/mp4">
        브라우저가 비디오를 지원하지 않습니다.
      </video>
      <!-- CSS로 만든 화살표 버튼 -->
<!--      <button class="hero-video__scroll-btn" @click="scrollToContent" aria-label="아래로 스크롤">-->
<!--        <div class="arrow-down"></div>-->
<!--      </button>-->
    </div>

      <div class="main-area-2__cta-area" ref="nextSection">
        <div class="main-area-2__cta-area-title">
          필요한 정보 <br>
          지금 바로 확인하세요!
        </div>

      <ul class="main-area-2__cta-area-list">
        <li v-for="cta in ctas" :key="cta.text">
          <router-link class="el-btn" :to="cta.link">
            <img :src="cta.src" :alt="cta.text +' 아이콘'" :width="cta.width">
            <span>{{cta.text}}</span>
          </router-link>
        </li>
      </ul>
    </div>

    <div class="main-area-3__cta-area main-area">
      <h3>
        소리가 예전처럼 <br>
        잘 들리지 않으세요?
      </h3>
      <p>
        <img :src="iconMainCheck" alt="체크 아이콘" width="34"> TV 소리를 점점 키우게 되나요? <br>
        <img :src="iconMainCheck" alt="체크 아이콘" width="34">요즘 전화 통화 시 말을 되묻게 되나요? <br>
        <img :src="iconMainCheck" alt="체크 아이콘" width="34">시끄러운 곳에서 대화하는 것이 어렵나요? <br>
        <img :src="iconMainCheck" alt="체크 아이콘" width="34">어떤 소리가 너무 크게 느껴진 적이 있나요? <br>
        <img :src="iconMainCheck" alt="체크 아이콘" width="34">울리는 소리, 으르렁대는 소리가 들리나요? <br>
      </p>
      <button @click="()=>toRouter('/customer/consultation')">무료 청력검사 신청하기</button>
    </div>

    <div class="main-area-4__cta-area main-area">
      <h3>
        보청기, 꼭 껴야 하나 <br>
        고민되시죠?
      </h3>
      <p>
        보청기를 착용하면 대화가 즐거워집니다.<br>
        생활 소리를 놓치지 않아 안전을 지켜줍니다.<br>
        사회적 고립감이 줄고 생활에 활력이 생깁니다.<br>
        생활 환경 맞춤형으로 쉽게 적응할 수 있습니다.<br>
        최대 30일 무료 체험으로 부담 없이 시작해보세요.<br>
      </p>
      <button @click="()=>toRouter('/customer/consultation')">무료체험 신청하기</button>

    </div>

    <div class="main-area-5__cta-area main-area">
      <h3>
        다비치 히어링 보청기,<br>
        전국 동일 서비스 약속해요!
      </h3>
      <img src="@/assets/images/mains/main-03-map.svg" alt="히어링 매징 전국 지도">
      <ul class="main-area-5__cta-area-list">
        <li>사전 예약 시 무료 청력검사 가능합니다.</li>
        <li>최대 30일 보청기 무료 착용이 가능합니다.</li>
        <li>전국 가격 정찰제로 제공합니다.</li>
        <li>30일 내 부적응 판정 시 환불해드립니다.</li>
        <li>전국 가맹점에서 무료 사후관리 가능합니다.</li>
      </ul>
      <button @click="()=>toRouter('/customer/store-locator')">우리동네 매장 찾기</button>

    </div>
    <div class="main-area-5-1__cta-area">
        <div v-for="hearingAid in hearingAids" :key="hearingAid.text">
          <router-link :to="hearingAid.link">
            <img :src="hearingAid.src" :srcset="hearingAid.srcset" :alt="hearingAid.text + ' 아이콘'" :width="hearingAid.width">
            <span>{{hearingAid.text}}</span>
          </router-link>
        </div>

    </div>

    <div class="main-area-6__cta-area main-area">
      <h3>
        보청기 쓰며 달라진 생활, <br>
        진짜 후기를 확인해보세요.<br>
      </h3>
      <p>
        보청기 착용 후 만족도가 궁금하시다면<br>
        지역별, 연령별 내 이웃의 후기를 확인해보세요.<br><br>
        무료 청력검사부터 보청기 체험 후기까지<br>
        고객님들의 솔직한 이야기를 공개합니다.
      </p>

      <div class="main-area-6__reviews">
        <div class="main-area-6__review"  v-for="review in reviews" :key="review.text">
<!--          <router-link to="/">-->
            <img :src="review.src" :alt="review.text">
<!--          </router-link>-->
        </div>
      </div>
      <button @click="()=>toRouter('/reviews/hearing-test')">
        청력검사 · 착용 후기 보기
      </button>
    </div>

    <div class="main-area-7__board main-area" >
      <div>
        <h3>건강 정보</h3>
        <ul>
          <li
            v-for="healthBoard in healthBoards"
            :key="healthBoard.id"
            @click="goToBoardDetail('/information/health', healthBoard.id)"
          >
            {{healthBoard.title}}
          </li>
        </ul>
      </div>
      <div>
        <h3>공지사항</h3>
        <ul>
          <li
            v-for="notice in noticeBoards"
            :key="notice.id"
            @click="goToBoardDetail('/customer/notice', notice.id)"
          >
            {{notice.title}}
          </li>
        </ul>
      </div>
    </div>

    <router-link to="/customer/consultation">
      <div class="main-area-1__cta-area" ref="contentArea">
        <div>무료 상담신청</div>
        <div>연락처 남기고 간편 상담 신청하기</div>
      </div>
    </router-link>

    <pop-up></pop-up>

  </div>
</template>

<script>
  import iconHearingAidPrice from '@/assets/icons/icon-hearing-aid-price.svg';
  import iconHearingAidSupport from '@/assets/icons/icon-hearing-aid-support.svg';
  import iconApplication from '@/assets/icons/icon-application-w.svg';
  import iconFindStore from '@/assets/icons/icon-find-store-w.svg';
  import iconMainCheck from '@/assets/icons/icon-main-check.svg';

  import open_2x from '@/assets/images/mains/main_05_product_img_01@2x.png';
  import open_1x from '@/assets/images/mains/main_05_product_img_01.png';
  import ultraSmall_1x from '@/assets/images/mains/main_05_product_img_02.png';
  import ultraSmall_2x from '@/assets/images/mains/main_05_product_img_02@2x.png';
  import drumhead_1x from '@/assets/images/mains/main_05_product_img_03.png';
  import drumhead_2x from '@/assets/images/mains/main_05_product_img_03@2x.png';
  import earring_1x from '@/assets/images/mains/main_05_product_img_04.png';
  import earring_2x from '@/assets/images/mains/main_05_product_img_04@2x.png';

  import review1 from '@/assets/images/mains/main_review_img_01.png';
  import review2 from '@/assets/images/mains/main_review_img_02.png';
  import review3 from '@/assets/images/mains/main_review_img_03.png';
  import review4 from '@/assets/images/mains/main_review_img_04.png';
  import { fetchNewsAndNoticeList, fetchHealthInfoList } from "@/api";
  import PopUp from "@/components/PopUp.vue";

  export default {
    components: {
      PopUp,
    },
    data() {
      return {
        iconMainCheck,
        isVideoPlaying: false,
        ctas:[
          {
            text: '보청기 가격',
            src: iconHearingAidPrice,
            link: '/price/hearing-aid',
            width : 75
          },
          {
            text: '보청기 지원금',
            src: iconHearingAidSupport,
            link: '/price/subsidy',
            width : 75
          },
          {
            text: 'AS 안심 서비스 조회',
            src: iconApplication,
            link: '/customer/registration',
            width : 75
          },
          {
            text: '인근 매장 찾기',
            src: iconFindStore,
            link: '/customer/store-locator',
            width : 75
          }
        ],
        hearingAids :[
          {
            text: '오픈형',
            src: open_1x,
            srcset: `${open_1x} 1x, ${open_2x} 2x,`,
            link: '/hearing-aid/types',
            width : 86
          },
          {
            text: '초소형',
            src: ultraSmall_1x,
            srcset: `${ultraSmall_1x} 1x, ${ultraSmall_2x} 2x,`,
            link: '/hearing-aid/types',
            width : 86
          },
          {
            text: '고막형',
            src: drumhead_1x,
            srcset: `${drumhead_1x} 1x, ${drumhead_2x} 2x,`,
            link: '/hearing-aid/types',
            width : 86
          },
          {
            text: '귀걸이형',
            src: earring_1x,
            srcset: `${earring_1x} 1x, ${earring_2x} 2x,`,
            link: '/hearing-aid/types',
            width : 86
          },
        ],
        reviews :[
          {
            text: '리뷰1',
            src: review1,
            link: '/',
          },
          {
            text: '리뷰2',
            src: review2,
            link: '/',
          },
          {
            text: '리뷰3',
            src: review3,
            link: '/',
          },
          {
            text: '리뷰3',
            src: review4,
            link: '/',
          },
        ],
        healthBoards: [],
        noticeBoards: [],
      };
    },

  mounted() {
    // body 스크롤 복원 (다른 페이지에서 막혀있을 수 있음)
    document.body.style.overflow = "";

    this.initVideo();

    // 페이지 가시성 변경 시 비디오 재생 관리
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  },

  async created() {
    await this.loadBoardData();
  },

  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  },

  methods: {
    async loadBoardData() {
      const params = {
        page: 1,
        size: 3
      };

      try {
        // 공지사항 3개 조회
        const noticeResponse = await fetchNewsAndNoticeList(params);
        this.noticeBoards = noticeResponse.data;
      } catch (e) {
        console.error('공지사항 조회 에러:', e);
      }

      try {
        // 건강 정보 3개 조회
        const healthResponse = await fetchHealthInfoList(params);
        this.healthBoards = healthResponse.data;
      } catch (e) {
        console.error('건강 정보 조회 에러:', e);
      }
    },

    goToBoardDetail(basePath, id) {
      this.$router.push(`${basePath}/${id}`);
    },

    toRouter(url) {
      this.$router.push(url);
    },

    async initVideo() {
      const video = this.$refs.heroVideo;

      if (!video) return;

      try {
        // 비디오 재생 시도
        await video.play();
        this.isVideoPlaying = true;
      } catch (error) {
        console.warn('비디오 자동 재생 실패:', error);

        // 자동 재생 실패 시 사용자 인터랙션 대기
        const playOnInteraction = () => {
          video.play().then(() => {
            this.isVideoPlaying = true;
            document.removeEventListener('click', playOnInteraction);
            document.removeEventListener('touchstart', playOnInteraction);
          });
        };

        document.addEventListener('click', playOnInteraction, { once: true });
        document.addEventListener('touchstart', playOnInteraction, { once: true });
      }
    },

    onVideoLoaded() {
      console.log('비디오 로드 완료');
    },

    onVideoEnded() {
      // loop 속성이 있지만 추가 보험
      const video = this.$refs.heroVideo;
      if (video) {
        video.currentTime = 0;
        video.play();
      }
    },

    handleVisibilityChange() {
      const video = this.$refs.heroVideo;
      if (!video) return;

      // 탭이 활성화되면 재생, 비활성화되면 일시정지 (성능 최적화)
      if (document.hidden) {
        video.pause();
      } else if (this.isVideoPlaying) {
        video.play();
      }
    },

    scrollToContent() {
      const nextSection = this.$refs.nextSection;
      if (nextSection) {
        nextSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  }
};
</script>

<style scoped lang="scss">
.hero-video {
  margin-top: var(--header-height);
  max-width: 500px;
  @media (max-width: 768px) {
  max-width: 768px;
  }
  //aspect-ratio: 2/3;  // 가로:세로 비율 고정 500px / 750px
  height: auto;
  //height: 732px;
  background-color: #e1ecf4ee;
  position: relative;
  overflow: hidden;

  &__player {
    width: 100%;
    height: 100%;
    object-fit: cover;
    will-change: transform;
    backface-visibility: hidden;
  }

  &__scroll-btn {
    position: absolute;
    bottom: 2.5rem;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(255, 255, 255, 0.2);
    border: 1px solid #fff;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s ease;
    backdrop-filter: blur(5px);

    &:hover {
      background: rgba(255, 255, 255, 0.4);
      transform: translateX(-50%) scale(1.1);

      .arrow-down {
        animation: bounce 1s infinite;
      }
    }

    &:active {
      transform: translateX(-50%) scale(0.95);
    }
  }

  @media (max-width: 768px) {
    //height: 400px;

    &__scroll-btn {
      width: 40px;
      height: 40px;
      bottom: 16px;
    }
  }
}

.arrow-down {
  width: 14px;
  height: 14px;
  border-bottom: 1px solid #fff;
  border-right: 1px solid #fff;
  transform: rotate(45deg);
  margin-top: -5px;

  @media (max-width: 768px) {
    width: 10px;
    height: 10px;
  }
}

.main-area {
  > h3 {
    font-family: Noto Sans KR;
    font-weight: 700;
    font-style: Bold;
    font-size: 38px;
    leading-trim: NONE;
    line-height: 62px;
    letter-spacing: -1.4px;
    vertical-align: middle;

    @media (max-width: 768px) {
      font-size: 26px;
      line-height: 40px;
      letter-spacing: -1.2px;
    }
  }

  button {
    width: 100%;
    background: #0032A5;
    font-family: font family/Font 1;
    font-weight: font weight/700;
    font-style: Bold;
    font-size: 20px;
    leading-trim: NONE;
    line-height: 62.5px;
    letter-spacing: -2%;
    text-align: center;
    vertical-align: middle;
    color: #fff;
    padding: 20px auto;

    @media (max-width: 768px) {
      font-size: 16px;
      line-height: 50px;
      padding: 15px auto;
    }
  }
}

.main-area-1__cta-area {
  z-index: 100;
  padding: 40px;
  color: #fff;
  //background: #008CFF;
  background: #C81B1E;
  bottom: 0;
  position: fixed;
  width: 100%;
  max-width: 500px;

  div:nth-child(1) {
    font-family: Noto Sans KR;
    font-weight: 700;
    font-size: 32px;
    line-height: 30px;
    letter-spacing: -0.02em;
    text-align: center;

    @media (max-width: 768px) {
      font-size: 22px;
      line-height: 28px;
    }
  }

  div:nth-child(2) {
    margin-top: 16px;
    font-family: Noto Sans KR;
    font-weight: 350;
    font-size: 22px;
    line-height: 30px;
    text-align: center;

    @media (max-width: 768px) {
      font-size: 16px;
      line-height: 24px;
      margin-top: 12px;
    }
  }

  @media (max-width: 768px) {
    padding: 30px 20px;

      max-width: 768px;

  }
}

.main-area-2__cta-area {
  background: #0032A5;
  padding: 54px 21px 37px;
  color: #fff;

  &-title {
    font-family: Noto Sans KR;
    font-weight: 700;
    font-style: Bold;
    font-size: 38px;
    leading-trim: NONE;
    line-height: 54px;
    letter-spacing: -2%;
    text-align: center;
    vertical-align: middle;

    @media (max-width: 768px) {
      font-size: 26px;
      line-height: 38px;
    }
  }

  ul {
    display: grid;
    grid-template:
      "a b"
      "c d";
    align-items: center;
    margin-top: 32px;

    li {
      color: #fff;
      font-weight: font weight/700;
      font-style: Bold;
      font-size: 22px;
      leading-trim: NONE;
      line-height: 22px;
      letter-spacing: 0%;
      text-align: center;
      vertical-align: middle;
      display: flex;
      justify-content: center;
      padding: 34px;

      a {
        display: flex;
        flex-direction: column;
        gap: 22px;
        align-items: center;
      }

      span {
        color: #fff;
      }
      &:hover{
        cursor: pointer;
        background: #00287c;
      }

      @media (max-width: 768px) {
        font-size: 16px;
        padding: 20px 10px;

        a {
          gap: 14px;
        }

        img {
          width: 50px !important;
          height: auto;
        }
      }
    }

    @media (max-width: 768px) {
      margin-top: 24px;
      gap: 0;
    }
  }

  @media (max-width: 768px) {
    padding: 40px 16px 30px;
  }
}
.main-area-3__cta-area {
  height: 805px;
  background-image: image-set(
    url('~@/assets/images/mains/main-bg-01.png') 1x,
    url('~@/assets/images/mains/main-bg-01@2x.png') 2x
  );

  p {
    margin-top: 22px;
    margin-bottom: 36px;
    font-family: Noto Sans KR;
    font-weight: 350;
    font-style: DemiLight;
    font-size: 20px;
    leading-trim: NONE;
    line-height: 44px;
    letter-spacing: -2%;
    vertical-align: middle;

    @media (max-width: 768px) {
      font-size: 16px;
      line-height: 32px;
      margin-top: 18px;
      margin-bottom: 24px;
    }
  }

  img {
    position: relative;
    top: 4px;
    margin-right: 6px;

    @media (max-width: 768px) {
      width: 24px !important;
      top: 2px;
      margin-right: 4px;
    }
  }

  @media (max-width: 768px) {
    height: auto;
    min-height: 500px;
    background-size: cover;
    background-position: center;
  }
}

.main-area-4__cta-area {
  height: 870px;
  background-image: image-set(
    url('~@/assets/images/mains/main-bg-02.png') 1x,
    url('~@/assets/images/mains/main-bg-02@2x.png') 2x
  );

  p {
    font-family: Noto Sans KR;
    font-weight: 350;
    font-style: DemiLight;
    font-size: 19px;
    leading-trim: NONE;
    line-height: 36px;
    letter-spacing: -1px;
    vertical-align: middle;
    margin-top: 22px;
    margin-bottom: 36px;

    @media (max-width: 768px) {
      font-size: 16px;
      line-height: 28px;
      margin-top: 18px;
      margin-bottom: 24px;
    }
  }

  @media (max-width: 768px) {
    height: auto;
    min-height: 710px;
    background-size: cover;
    background-position: center;
  }
}

.main-area-5__cta-area {
  background: linear-gradient(180deg, #FFFFFF 0%, #E4EDFF 100%);
  img {
    margin: 14px auto;
    display: block;

    @media (max-width: 768px) {
      max-width: 100%;
      height: auto;
      margin: 10px auto;
    }
  }

  &-list {
    margin-bottom: 36px;

    @media (max-width: 768px) {
      margin-bottom: 24px;
    }
  }

  li {
    list-style: circle inside;

    &::marker {
      background: #000;
      margin-right: 5px;
      color: #000;
    }

    font-family: Noto Sans KR;
    font-weight: 350;
    font-style: DemiLight;
    font-size: 18px;
    leading-trim: NONE;
    line-height: 36px;
    letter-spacing: -2%;
    vertical-align: middle;

    @media (max-width: 768px) {
      font-size: 16px;
      line-height: 28px;
    }
  }
}

.main-area-5-1__cta-area {
  a{
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  background: linear-gradient(180deg, #FFFFFF 5%, #d5ecff 100%);
  div {
    padding: 28px 0;
    display: flex;
    justify-content: left;
    padding-left: calc(50% - 82px);
    align-items: center;
    border-bottom: 1px dashed #0056AA;
  }
  div:last-child{
    border-bottom: none;
  }
  span {
    font-weight: 600;
    font-size: 24px;
    leading-trim: NONE;
    line-height: 24px;
    letter-spacing: -0.5px;
    text-align: center;
    vertical-align: middle;
    //display: block;
    margin-left: 36px;
    color: #0032A5;
  ;
  }
  @media (max-width: 768px) {
    div {
      img {
        width: 60px !important;
        height: auto;
      }
      span {
        font-size: 18px;
        margin-left: 16px;
      }
    }
  }
}

.main-area-6__cta-area {
  background: linear-gradient(180deg, #f5f5f5 0%,  #E4EDFF 100%);
  p {
    font-family: font family/Font 1;
    font-weight: font weight/350;
    font-style: DemiLight;
    font-size: 18px;
    leading-trim: NONE;
    line-height: 30px;
    letter-spacing: -4%;
    vertical-align: middle;
    margin: 22px 0 44px;

    @media (max-width: 768px) {
      font-size: 15px;
      line-height: 26px;
      margin: 18px 0 32px;
    }
  }
  .main-area-6__reviews{
    display: grid;
    grid-template:
      "a b"
      "c d";
    //align-items: center;
    gap: 12px;
    margin-bottom: 44px;
    img{
      width: 100%;
    }
  }
}
.main-area-7__board{
  h3{
    margin-top: 75px;
    margin-bottom: 25px;
    font-weight: 600;
    font-size: 31.25px;
    leading-trim: NONE;
    line-height: 31.25px;

    text-align: center;
    vertical-align: middle;
  }
  ul{
    li{
      font-family: font family/Font 1;
      font-weight: font weight/350;
      font-style: DemiLight;
      font-size: 18.75px;
      leading-trim: NONE;
      line-height: 31.25px;
      letter-spacing: 0%;
      vertical-align: middle;
      padding: 22px;
      border-top: 1.25px solid var(--color-grey-95, #EDEFF5);
      cursor: pointer;
      transition: background-color 0.2s ease;

      &:hover {
        background-color: #f8f9fa;
      }
    }
    li:last-child{
      border-bottom: 1.25px solid var(--color-grey-95, #EDEFF5);
    }
  }

  @media (max-width: 768px) {
    ul{
      li{
        font-size: 15px;
      }
    }
  }
}
.main-area-3__cta-area,
.main-area-4__cta-area,
.main-area-5__cta-area,
.main-area-6__cta-area,
.main-area-7__board{
  padding: 40px;

  @media (max-width: 768px) {
    padding: 30px 20px;
  }
}
</style>